// import axios from 'axios'
import baseURL from '../baseUrl'

// 获取结算商品数据
export function getBalanceGoods(data) {
  var url=baseURL?'/pc_getBalanceGoods':'/api/pc_getBalanceGoods'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 获取结算价格
export function updatePrice(data) {
  var url=baseURL?'/pc_getUpdatePrice':'/api/pc_getUpdatePrice'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 订单信息
export function orderinfo(data) {
  var url=baseURL?'/pc_orderinfo':'/api/pc_orderinfo'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 订单列表
export function orderlist(data) {
  var url=baseURL?'/pc_supplierOrder':'/api/pc_supplierOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 取消订单
export function cancelorder(data) {
  var url=baseURL?'/pc_cancelOrder':'/api/pc_cancelOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 获取拉黑原因列表
export function BlackReasonList(data) {
  var url=baseURL?'/pc_blackReasonList':'/api/pc_blackReasonList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 拉黑用户申请
export function userBlackApply(data) {
  var url=baseURL?'/pc_userBlackApply':'/api/pc_userBlackApply'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 获取省市区选择
export function getdata(data) {
  var url=baseURL?'/getdata':'/api/getdata'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 添加用户地址
export function addUserAddress(data) {
  var url=baseURL?'/pc_addUserAddress':'/api/pc_addUserAddress'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 钱包支付
export function qianbao(data) {
  var url=baseURL?'/payByWallet':'/api/payByWallet'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 微信支付
export function weixin(data) {
  var url=baseURL?'/pc_weixin':'/api/pc_weixin'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 支付宝支付
export function zhifubao(data) {
  var url=baseURL?'/pc_alipay':'/api/pc_alipay'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 售后管理
export function customerService(data) {
  var url=baseURL?'/pc_customerService':'/api/pc_customerService'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 售后详情
export function customerDetails(data) {
  var url=baseURL?'/pc_customerDetails':'/api/pc_customerDetails'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 审核
export function customerAuditing(data) {
  var url=baseURL?'/pc_customerAuditing':'/api/pc_customerAuditing'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 小程序订单审核
export function auditRefund(data) {
  var url=baseURL?'/auditRefund':'/api/auditRefund'
  return axios({
    url,
    method: 'post',
    data: data
  })
}

// 获取配送方式
export function getShippingType(data) {
  var url=baseURL?'/pc_getShippingType':'/api/pc_getShippingType'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 编辑地址
export function updateAddress(data) {
  var url=baseURL?'/pc_updateAddress':'/api/pc_updateAddress'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 删除地址
export function addressdel(data) {
  var url=baseURL?'/pc_deletaAddress':'/api/pc_deletaAddress'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 地址列表
export function UserAddress(data) {
  var url=baseURL?'/pc_userAddress':'/api/pc_userAddress'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 提交订单优惠券列表
export function getUserUseCouponList(data) {
  var url=baseURL?'/getUserUseCouponList':'/api/getUserUseCouponList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

//续租价格
export function xuzuprice(data) {
  var url=baseURL?'/pc_xuzuprice':'/api/pc_xuzuprice'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//去发货
export function qufahuo(data) {
  var url=baseURL?'/pc_deliver':'/api/pc_deliver'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//确认收货
export function qurenshouhuo(data) {
  var url=baseURL?'/pc_qurenOrder':'/api/pc_qurenOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//确认归还
export function qrguihuan(data) {
  var url=baseURL?'/pc_guihuanOrder':'/api/pc_guihuanOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//获取订单信息
export function getorder(data) {
  var url=baseURL?'/pc_orderInfo':'/api/pc_orderInfo'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//支付宝支付
export function alipay(data) {
  var url=baseURL?'/aliPayRecharge':'/api/aliPayRecharge'
  return axios({
    // url: '/pc_activealipay',
    url,
    method: 'post',
    params: data
  })
}

//闪送相关-通知闪送取件
export function pickgood(data) {
  var url=baseURL?'/pc_pickgood':'/api/pc_pickgood'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

//闪送相关-查看闪送订单
export function chekgood(data) {
  var url=baseURL?'/pc_chekgood':'/api/pc_chekgood'
  return axios({
    url,
    method: 'get',
    params: data
  })
}

//闪送相关-取消闪送订单
export function cancleorder(data) {
  var url=baseURL?'/pc_cancleorder':'/api/pc_cancleorder'
  return axios({
    url,
    method: 'get',
    params: data
  })
}

//闪送相关-查询闪送的订单号
export function getnumber(data) {
  var url=baseURL?'/pc_getnumber':'/api/pc_getnumber'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

//闪送相关-确认发货
export function deliverygoods(data) {
  var url=baseURL?'/pc_deliverygoods':'/api/pc_deliverygoods'
  return axios({
    url,
    method: 'get',
    params: data
  })
}

//租赁协议
export function getDocument(data) {
  var url=baseURL?'/pc_getDocument':'/api/pc_getDocument'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


export function createReletOrder(data) {
  var url=baseURL?'/createReletOrder':'/api/createReletOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

export function createContinueReletOrder(data) {
  var url=baseURL?'/createContinueReletOrder':'/api/createContinueReletOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

export function getUpdateReletPrice(data) {
  var url=baseURL?'/getUpdateReletPrice':'/api/getUpdateReletPrice'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/order/order.js